module.exports = __webpack_public_path__ + "static/media/fohat.ba9f8131.png";